import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "placeholder"]

import { handleMask } from "@/utils";

export type InputProps = {
  type?: string;
  hasError?: boolean;
  placeholder?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: /*@__PURE__*/_mergeModels({
    type: { default: "text" },
    hasError: { type: Boolean, default: false },
    placeholder: { default: "" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const model = _useModel<string>(__props, "modelValue");

const applyMask = (event: Event) => {
  const target = event.target as HTMLInputElement;

  // Aplica a máscara
  const maskedValue = handleMask(event);

  // Atualiza o valor do input e o modelo
  target.value = maskedValue;
  model.value = maskedValue; // Isso irá emitir automaticamente o evento do v-model
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.hasError }]),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    type: _ctx.type,
    placeholder: _ctx.placeholder,
    onInput: applyMask
  }, null, 42, _hoisted_1)), [
    [_vModelDynamic, model.value]
  ])
}
}

})